import { IUser } from "../../types/types";
import { api } from "./api";

// טיפוסים חדשים בהתאם לשרת - מתאים למבנה הנתונים שהשרת מחזיר
export interface RiskAlertServerResponse {
  id: number;
  userId: number;
  questionnaireId: number | null;
  updatedAt: string; // "2025-10-19T15:40:19.143"
  riskLevel: "Red" | "Orange" | "Green";
  riskLabel: string;
  sourceName: string;
  actionsPerformed: string | null;
  nextSteps: string | null;
  createdAt: string;
  aiSummary: string | null;
  patientFullName: string;
  age: number | null;
  companyId: number;
  user: IUser;
}

export interface UpdateRiskAlertRequest {
  actionsPerformed?: string | null; // ✅ optional + nullable
  nextSteps?: string | null;         // ✅ optional + nullable
}

export const riskAlertsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRiskAlerts: build.query<RiskAlertServerResponse[], { 
      userGuid?: string; 
      closed?: boolean 
    }>({
      query: ({ userGuid, closed = false }) => ({
        url: `/Admintech/AI_GetRiskAlerts/${userGuid || ''}`,
        method: "GET",
        params: {
          closed
        }
      }),
      providesTags: ["RiskAlerts"],
    }),    
    updateRiskAlert: build.mutation<void, { id: number; data: UpdateRiskAlertRequest }>({
      query: ({ id, data }) => ({
        url: `/Admintech/RiskAlerts/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["RiskAlerts"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetRiskAlertsQuery,
  useUpdateRiskAlertMutation,
} = riskAlertsApi;
